<template>
  <b-container class="" fluid>
    <b-row>
      <b-col cols="12" class="pt-4  gray-background"> </b-col>
    </b-row>

    <b-row class="image-container-row gray-background">
      <b-col class="px-0 mx-0 c-center text-center">
        <img class="img-height-max" src="/images/home/trappe.jpg" height="400" />
      </b-col>
      <b-col class="px-0 mx-0 c-center text-center d-none d-lg-block">
        <img class="img-height-max" src="/images/home/niels.jpg" height="400" />
      </b-col>
    </b-row>
    <b-row class="d-block d-lg-none gray-background white-text">
      <b-col col sm="auto" class="pb-4 text-center">
        Siden er ikke optimeret til telefoner. <br />
        Besøg venligst <a href="https://nielsvium.dk">www.nielsvium.dk</a> fra en computer eller tablet.
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" class="pt-4  gray-background"> </b-col>
    </b-row>

  </b-container>
</template>

<script>
export default {
  name: "home",
  components: {

  }
};
</script>


<style scoped lang="scss">
@import "@/variables.scss";

.small-text {
  font-size: 10px;
}

.white-text {
  color: white;

  a {
    color: white;
    text-decoration: underline;
  }
}
</style>
